import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { PortalHighlight } from "@/components/landing/PortalHighlight";
import { Footer } from "@/components/landing/Footer";
import { useLenis } from "@/components/landing/useLenis";

function App() {
  useLenis();
  return (
    <div className="min-h-screen overflow-x-hidden bg-white">
      <Header />
      <main>
        <Hero />
        <PortalHighlight />
      </main>
      <Footer />
    </div>
  );
}

export default App;
